export default __webpack_public_path__ + "static/media/googlesignin.df6ccc98.png";